import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { TaskViewScope } from "./constants"

import {
  PriceChangeHistorySortField,
  QualityApprovalPendingSortField,
  QualityApprovalRequestSortField,
  QualityApprovalRequestStatusFilter,
  SortingOrder,
} from "@/graphql/codegen/graphql"

export const pendingApprovalsSearchSchema = z.object({
  taskViewScope: fallback(z.nativeEnum(TaskViewScope), TaskViewScope.MyTasks),
})

export const priceApprovalSearchSchema = z.object({
  query: z.string().optional(),
  field: fallback(z.nativeEnum(PriceChangeHistorySortField), PriceChangeHistorySortField.UpdatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
})

export type PriceApprovalSearchParams = z.infer<typeof priceApprovalSearchSchema>

export const qualityApprovalSearchSchema = z.object({
  field: fallback(z.nativeEnum(QualityApprovalPendingSortField), QualityApprovalPendingSortField.ProductId),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export type QualityApprovalSearchParams = z.infer<typeof qualityApprovalSearchSchema>

export const qualityRequestSearchSchema = z.object({
  query: z.string().optional(),
  status: fallback(z.nativeEnum(QualityApprovalRequestStatusFilter), QualityApprovalRequestStatusFilter.All),
  field: fallback(z.nativeEnum(QualityApprovalRequestSortField), QualityApprovalRequestSortField.Status),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
})

export type QualityRequestSearchParams = z.infer<typeof qualityRequestSearchSchema>
